import React from 'react'
import iphone from "../assets/iphone.png"

const FlappyBase = () => {
    return (
        <>
         <div className='h-full md:w-[1442px] w-full flex items-center justify-center flex-col'>
            <section className='bg-black flex justify-center md:flex-row flex-col'>
                <article className='md:w-[55%] w-full flex px-20 mt-10 flex-col'>
                    <h1 className='md:text-[5rem] text-[3rem]'>Meet</h1>
                    <h1 className='md:text-[5rem] text-[#0052FF] text-[3rem]'>Flappy Base</h1>
                    <p className='text-[#E4E4E4] md:w-[80%] text-2xl mt-3'>Play-to-earn game inspired by Flappy Bird, where users farm $ETH while playing, and use $FLAPPY to boost their powers.</p>
                </article>
                <figure className='md:w-[40%] w-full flex items-center justify-center flex-col mt-5'>
                    <img src={iphone} alt="" className='mr-32'/>
                </figure>
            </section>
            </div>
        </>
    )
}

export default FlappyBase
